import React from "react";
import { Layout, Menu } from "antd"; 
import { PhoneOutlined, MailOutlined, MobileOutlined } from "@ant-design/icons";
import Testimonials from "./Testimonials";
const { Header, Content, Footer } = Layout;

const App: React.FC = () => {
  
  const currentYear = new Date().getFullYear();
  const onChange = (currentSlide: number) => {
    console.log(currentSlide);
  };
  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Header className="header-wrapper">
        <section className="contact-header">
          <div className="contact-header-left-wrapper">
            <a href="tel:0469038139" className="border-right">
              <PhoneOutlined className="phone-icon" />
              <span>0469038139</span>
            </a>
            <a href="mailto:anpupainting@gmail.com" target="new">
              <MailOutlined className="icon" />
              <span>anpupainting@gmail.com</span>
            </a>
          </div>
        </section>
        <nav className="header">
          <div className="logo-wrapper">
            <img src="/aupulogo.png" alt="logo" className="logo" />
            <span className="header-title">Anpu Painting</span>
          </div>
          <Menu theme="light" mode="horizontal" className="menu">
            <Menu.Item className="menu-item" key="1">
              Home
            </Menu.Item>
            <Menu.Item className="menu-item" key="2">
              Service
            </Menu.Item>
            <Menu.Item className="menu-item" key="3">
              Testimonials
            </Menu.Item>
            <Menu.Item className="menu-item" key="4">
              Contact
            </Menu.Item>
          </Menu>
          <div className="contact-header-right-wrapper">
            <MobileOutlined className="mobile-icon" />
            <div className="call-now-wrapper">
              <span className="call-now-text">Call Now</span>
              <a href="tel:0469038139">0469038139</a>
            </div>
          </div>
        </nav>
      </Header>

      <Layout>
        <Layout>
          <Content className="site-layout-background">
            <div className="home-page">
              <div className="home-header-title">
                <h2>We Bring Your Home To Lively Colors</h2>
                <p>
                  We specialize in transforming your living spaces with vibrant,
                  beautiful, and professional wall painting services. Whether
                  you're looking to refresh a single room or give your entire
                  home a bold new look, our expert painters are here to help.
                </p>
                <p>
                  From modern, minimalistic tones to bright, cheerful palettes,
                  we tailor our services to match your vision. Using
                  high-quality materials and a keen eye for detail, we ensure a
                  flawless finish every time. Let us bring your home to life
                  with colors that inspire joy and comfort.
                </p>
              </div>
              <div>
                <img src="/anpu.png" alt="anpu" />
              </div>
            </div>
            <div className="service-page">
              <h2>Our Services</h2>
              <div className="service-wrapper">
                <div>
                  <h3>House Painting</h3>
                </div>
                <div>
                  <h3>Interior Painting</h3>
                </div>
                <div>
                  <h3>EXterior Painting</h3>
                </div>
                <div>
                  <h3>Fence Painting</h3>
                </div>
                <div>
                  <h3>Floor Painting</h3>
                </div>
                <div>
                  <h3>Driveway Painting</h3>
                </div>
              </div>
            </div>
            <Testimonials />
            <div className="contact-page">
              <h2>Contact</h2>
              <div className="contact-wrapper">
                
              </div>
            </div>
          </Content>
        </Layout>
      </Layout>

      <Footer className="camezo-footer">
        <p>© {currentYear} Anpu Painting. All Rights Reserved.</p>
        <p>
          Designed by{" "}
          <a href="https://www.camezo.com.au" target="new">
            <img
              src="https://www.camezo.com.au/images/logo.png"
              className="camezo-logo"
              alt="created by"
              width={75}
            />{" "}
          </a>
        </p>
      </Footer>
    </Layout>
  );
};

export default App;
